"use strict";

exports.__esModule = true;
exports.default = void 0;
var _routes = _interopRequireDefault(require("./routes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const config = {
  translateElementsTable: {
    schema: {
      /* 
      Id: {
      displayName: 'ID',
      type: 'String',
      sortable: true,
      filterable: true,
      show: false,
      }, */
      Category: {
        displayName: 'Category',
        type: 'String',
        value: '',
        key: 'Category',
        guarded: true,
        sortable: true
      },
      TranslationId: {
        displayName: 'ID',
        type: 'String',
        value: '',
        key: 'TranslationId',
        guarded: true,
        sortable: true,
        filterable: true
      },
      LanguageFrom: {
        displayName: 'From ',
        type: 'String',
        value: '',
        key: 'LanguageFrom',
        sortable: true,
        filterable: true,
        headerType: 'Dropdown'
      },
      LanguageTo: {
        displayName: 'To ',
        type: 'String',
        value: '',
        key: 'LanguageTo',
        sortable: true,
        filterable: true,
        editable: false,
        headerType: 'Dropdown'
      }
    } /* 
      Comment: {
      displayName: 'Comment',
      type: 'String',
      value: '',
      sortable: true,
      filterable: true,
      },*/
  },
  routes: _routes.default
};
var _default = exports.default = config;
module.exports = exports.default;